import { REQUEST_STATUS } from '@/constants/request-status'
import { apiStudent } from '@/lib/api-manager'
import type { StudentRequest } from '@/types/student/student-request.type'

export async function getStudentRequests() {
  const result = await apiStudent.get('v1/requests/students')
  const data: StudentRequest[] = result.data
  return data.map((request) => {
    if (request.requestStatus.id === REQUEST_STATUS.NOT_STARTED.id) {
      request.requestStatus.id = REQUEST_STATUS.UNDER_REVIEW.id
      request.requestStatus.name = REQUEST_STATUS.UNDER_REVIEW.name
    }

    request.createdAt = new Date(request.createdAt)

    return request
  })
}
